import React from "react";


const Card5 = ({ data }) => {
  return (
    <div
      className={`min-h-screen w-full ${data?.selectedTheme?.swatches?.light.bg}`}
    >


      <div className="mx-auto flex min-h-screen w-full max-w-[420px] flex-col  py-6">
        {/* Icônes sociales en haut */}
        {data?.socialLinks?.length > 0 && (
          <div className="mb-4 flex items-center gap-4 px-8 py-2">
            {data.socialLinks.map((social) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.id}
                  href={social.url}
                  target="_blank"
                  rel="noreferrer"
                  className={`${data?.selectedTheme?.swatches?.secondary.text || "text-[#5b8fc7]"} transition hover:scale-110`}
                >
                  {Icon ? (
                    <Icon size={32} strokeWidth={2} />
                  ) : (
                    <span className="text-sm">{social.id}</span>
                  )}
                </a>
              );
            })}
          </div>
        )}

        {/* Carte principale */}
        <div className="w-full rounded-[24px] bg-white p-5 shadow-sm">
          {/* Nom */}
          <h3
            className={`text-[34px] font-extrabold leading-tight ${data?.selectedTheme?.swatches?.secondary.text || "text-[#3d6fa5]"}`}
          >
            {data?.displayName}
          </h3>

          {/* Tagline */}
          <h4
            className={`mt-1 text-[15px] font-medium ${data?.selectedTheme?.swatches?.secondary.text || "text-[#5b8fc7]"}`}
          >
            {data?.tagline}
          </h4>

          {/* Photo */}
          <div className="mt-4 aspect-square w-full overflow-hidden rounded-[16px]">
            <img
              src={data?.photo?.url}
              alt={data?.displayName}
              className="h-full w-full object-cover"
            />
          </div>

          {/* Bio */}
          <p className="mt-4 text-[13px] leading-[1.5] text-[#3a3a3a]">
            {data?.bio}
          </p>

          {/* Boutons en grille 2 colonnes */}
          <div className="mt-5 grid grid-cols-2 gap-3">
            {data?.filteredLinks?.map((link) => (
              <a
                key={link.id}
                target="_blank"
                rel="noreferrer"
                href={data?.platformLinks?.[link.id]}
                className={`flex h-[42px] items-center justify-between rounded-[10px] ${data?.selectedTheme?.swatches?.secondary.bg} px-4 text-[13px] font-medium text-white transition duration-300 hover:scale-[1.02] hover:shadow-lg`}
              >
                <span className="truncate">{link.title}</span>
                <span className="ml-2">→</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card5;